<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'flowNo'" :required="isRequired('flowNo')" v-model="formData.flowNo"
                   :rules="getRules('flowNo')" label="编号" input-align="right" readonly/>
        <van-field v-f-show="'fksqr'" v-model="formData.fksqr" :required="isRequired('fksqr')" name="flowName"
                   label="付款申请人" placeholder="付款申请人" input-align="right" :rules="getRules('fksqr')">
          <template #input>
            <view-item @click.native="isShowPopup(deptUserTreeAll,'fksqr')" :treeData="deptUserTreeAll.data"
                       :value="formData.fksqr" placeholder="请选择付款申请人"/>
            <van-popup position="bottom" v-model="deptUserTreeAll.show">
              <van-nav-bar title="选择付款申请人" left-text="取消" right-text="确定"
                           @click-left="deptUserTreeAll.show = false" @click-right="handlePopupSubmit"/>
              <van-search v-model="deptUserTreeAll.filterText" @input="treeSearch($event, $refs.tree)" clearable
                          shape="round"/>
              <div style="overflow-y: auto" class="h-vh-35">
                <div class="p-10">
                  <el-tree ref="tree" @check-change="singleChoice($event,$refs.tree)" node-key="uuid" check-strictly
                           :data="deptUserTreeAll.data" :filter-node-method="filterNode" check-on-click-node
                           show-checkbox/>
                </div>
              </div>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'sqr'" v-model="formData.sqr" :required="isRequired('sqr')" name="flowName" label="申请人"
                   placeholder="申请人" input-align="right" :rules="getRules('sqr')">
          <template #input>
            <view-item :value="formData.sqr" placeholder="请选择申请人"/>
          </template>
        </van-field>
        <van-field v-f-show="'ssbm'" input-align="right" name="ssbm" :required="isRequired('ssbm')"
                   :value="formData.ssbm" label="部门" :rules="getRules('ssbm')" placeholder="请选择部门">
          <template #input>
            <view-item @click.native="isShowPopup(ssbm,'ssbm')" :value="formData.ssbm" placeholder="请选择部门"/>
            <van-popup v-model="ssbm.show" position="bottom">
              <van-nav-bar title="选择部门" left-text="取消" right-text="确定" @click-left="ssbm.show = false"
                           @click-right="popupSubmit('ssbm',{label:'label',value:'value'})"/>
              <van-search v-model="ssbm.filterText" @input="pickerSearch($event,ssbm,'label')" clearable shape="round"/>
              <van-picker ref="ssbm" value-key="label" :columns="ssbm.filteredData" @cancel="ssbm.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field v-f-show="'hsgs'" input-align="right" name="hsgs" :value="formData.hsgs" :rules="getRules('hsgs')"
                   label="核算公司" placeholder="请选择核算公司">
          <template #input>
            <view-item @click.native="isShowPopup(hsgs,'hsgs')" :value="formData.hsgs" placeholder="请选择核算公司"/>
            <van-popup v-model="hsgs.show" position="bottom">
              <van-nav-bar title="选择核算公司" left-text="取消" right-text="确定" @click-left="hsgs.show = false"
                           @click-right="popupSubmit('hsgs',{label:'name',value:'id'})"/>
              <!-- <van-search v-model="hsgs.filterText" @input="pickerSearch($event,hsgs,'accountName')" clearable shape="round"/> -->
              <van-picker :duration="0" ref="hsgs" value-key="name" :columns="hsgs.filteredData"
                          @cancel="hsgs.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <!--        <van-field v-f-show="'ssxm'" input-align="right" name="ssxm" :required="isRequired('ssxm')" :value="formData.ssxm" :rules="getRules('ssxm')" label="所属项目" placeholder="请选择项目">-->
        <!--          <template #input>-->
        <!--            <view-item @click.native="isShowPopup(ssxm,'ssxm')" :value="formData.ssxm" placeholder="请选择项目"/>-->
        <!--            <van-popup v-model="ssxm.show" position="bottom">-->
        <!--              <van-nav-bar title="选择项目" left-text="取消" right-text="确定" @click-left="ssxm.show = false" @click-right="popupSubmitSsxm('ssxm',{label:'projectName',value:'projectId'})"/>-->
        <!--              <van-search v-model="ssxm.filterText" @input="pickerSearch($event,ssxm,'projectName')" clearable shape="round"/>-->
        <!--              <van-picker :duration="0" ref="ssxm" value-key="projectName" :columns="ssxm.filteredData" @cancel="ssxm.show = false"/>-->
        <!--            </van-popup>-->
        <!--          </template>-->
        <!--        </van-field>-->
        <!--        <van-field v-f-show="'ssxm'" input-align="right" name="ssxm" :value="formData.ssxm" v-model="formData.ssxm" :rules="getRules('ssxm')" label="关联业务" placeholder="请选择所属项目/合同">-->
        <!--          <template #input>-->
        <!--            <view-item @click.native="showContract()" :showLabel="formData.ssxmLabel" :value="formData.ssxm" placeholder="请选择项目/合同"/>-->
        <!--          </template>-->
        <!--        </van-field>-->
        <van-field v-f-show="'ssxm'" input-align="right" name="ssxm" :required="isRequired('ssxm')"
                   :value="formData.ssxm"
                   :rules="getRules('ssxm')" label="关联业务" placeholder="请选择项目/合同">
          <template #input>
            <view-item @click.native="isShowPopup(ssxm,'ssxm')" :value="formData.ssxm.split(',')[1]"
                       placeholder="请选择项目/合同"/>
            <van-popup v-model="ssxm.show" position="bottom">
              <van-nav-bar title="选择项目/合同" left-text="取消" right-text="确定" @click-left="ssxm.show = false"
                           @click-right="businessSelectFinish('ssxm')"/>
              <van-row type="flex" align="center" class="p-r-20">
                <van-col :span="18">
                  <van-search v-model="ssxm.filterText" @input="pickerSearch($event,ssxm,'name','columnsLabel')" clearable
                              shape="round"/>
                </van-col>
                <van-col :span="6">
                  <van-button :loading="btnLoading" @click="selectMyProjectList('',true)" loading-text="加载中..."
                              type="primary" native-type="button" size="small">更多项目...
                  </van-button>
                </van-col>
              </van-row>
              <van-picker :duration="0" ref="ssxm" value-key="columnsLabel" :columns="ssxm.filteredData"
                          @cancel="ssxm.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field v-f-show="'fksy'" v-model="formData.fksy" :disabled="isDisabled('fksy')"
                   :required="isRequired('fksy')" name="fksy" :rules="getRules('fksy')" type="textarea" maxlength="200"
                   rows="3" autosize label="付款事由" show-word-limit placeholder="请输入付款事由" input-align="right"/>
      </van-cell-group>
      <div class="font-32 font-weight-500 cor-00 m-t-26">付款明细</div>
      <van-cell-group class="m-t-20">
        <van-field v-f-show="'fklx'" input-align="right" name="fklx" :required="isRequired('fklx')"
                   :rules="getRules('fklx')" :value="formData.fklx" label="付款类型" placeholder="请选择付款类型">
          <template #input>
            <view-item @click.native="isShowPopup(fklx,'fklx')" :value="formData.fklx" placeholder="请选择付款类型"/>
            <van-popup v-model="fklx.show" position="bottom">
              <van-nav-bar title="选择付款类型" left-text="取消" right-text="确定" @click-left="fklx.show = false"
                           @click-right="popupSubmit('fklx')"/>
              <van-search v-model="fklx.filterText" @input="pickerSearch($event,fklx)" clearable shape="round"/>
              <van-picker ref="fklx" :columns="fklx.filteredData" @cancel="fklx.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'zmlx'" input-align="right" name="zmlx" :required="isRequired('zmlx')"
                   :rules="getRules('zmlx')" label="账套类型" placeholder="请选择账套类型">
          <template #input>
            <view-item v-if="isDisabled('zmlx')" :showLabel="formData.zmlx"/>
            <van-checkbox-group v-else v-model="formData.zmlx" style="display: flex;" checked-color="rgb(255,218,62)">
              <van-checkbox name="管理账套" style="margin-right: 10px;">管理账套</van-checkbox>
              <van-checkbox name="核算账套">核算账套</van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field v-f-show="'fkze'" :disabled="isDisabled('fkze')" v-model="formData.fkze" type="number" name="fkze"
                   :rules="getRules('fkze')" :required="isRequired('fkze')" :maxlength="10" placeholder="请输入付款总额"
                   label="付款总额(元)" input-align="right" @change="formatToTwoDecimals(formData, 'fkze')"></van-field>
        <van-field v-f-show="'fkze'" center v-model="formData.fkze" :rules="getRules('fkze')"
                   :required="isRequired('fkze')" label="" input-align="right" readonly>
          <template #input>
            <div>
              <span v-text="getFormatValue(formData.fkze)+' 元'" v-if="formData.fkze && formData.fkze!=0"></span>
              <span v-else>无</span>
              <div v-if="formData.fkze && formData.fkze!=0">
                <span class="p-l-20"> 大写：</span>
                <span class="cor-F64646">{{ getChinese(formData.fkze) }}</span>
              </div>
            </div>
          </template>
        </van-field>

        <van-field v-f-show="'zfrq'" v-model="formData.zfrq" :required="isRequired('zfrq')" name="zfrq" label="支付日期"
                   placeholder="支付日期" input-align="right" :rules="getRules('zfrq')">
          <template #input>
            <view-item @click.native="isShowPopup(zfrq,'zfrq')" :value="formData.zfrq" placeholder="请选择支付日期"/>
            <van-calendar v-model="zfrq.show" ref="zfrq" :min-date="zfrq.minDate" :max-date="zfrq.maxDate"
                          :show-confirm="false" title="选择支付日期"
                          @confirm="zfrqConfirm"></van-calendar>
          </template>
        </van-field>
        <van-field v-f-show="'fkfs'" input-align="right" name="fkfs" :required="isRequired('fkfs')"
                   :rules="getRules('fkfs')" :value="formData.fkfs" label="付款方式" placeholder="请选择付款方式">
          <template #input>
            <view-item @click.native="isShowPopup(fkfs,'fkfs')" :value="formData.fkfs" placeholder="请选择付款方式"/>
            <van-popup v-model="fkfs.show" position="bottom">
              <van-nav-bar title="选择付款方式" left-text="取消" right-text="确定" @click-left="fkfs.show = false"
                           @click-right="popupSubmit('fkfs')"/>
              <van-search v-model="fkfs.filterText" @input="pickerSearch($event,fkfs)" clearable shape="round"/>
              <van-picker ref="fkfs" :columns="fkfs.filteredData" @cancel="fkfs.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <div class="flex row-between col-center m-t-20">
          <van-button size="small" type="primary" @click="account.show = true" native-type="button">选择支付对象
          </van-button>
        </div>
        <van-field v-f-show="'zfdx'" v-model="formData.zfdx" :disabled="isDisabled('zfdx')"
                   :required="isRequired('zfdx')" name="zfdx" :rules="getRules('zfdx')" maxlength="50" autosize
                   label="支付对象" placeholder="请输入支付对象" input-align="right"/>
        <van-field v-f-show="'yhzh'" v-model="formData.yhzh" :disabled="isDisabled('yhzh')"
                   :required="isRequired('yhzh')" name="yhzh" :rules="getRules('yhzh')" maxlength="50" autosize
                   label="账号" placeholder="请输入账号" input-align="right"/>
        <van-field v-f-show="'khh'" v-model="formData.khh" :disabled="isDisabled('khh')" :required="isRequired('khh')"
                   name="khh" :rules="getRules('khh')" maxlength="50" autosize label="开户行" placeholder="请输入开户行"
                   input-align="right"/>
        <van-field v-f-show="'skrfkbz'" v-model="formData.skrfkbz" :disabled="isDisabled('skrfkbz')"
                   :required="isRequired('skrfkbz')" :rules="getRules('skrfkbz')" name="skrfkbz" type="textarea"
                   maxlength="200" rows="3" autosize label="付款备注" show-word-limit
                   placeholder="请在填写付款备注时，避免使用 “福利、劳务费、工资、薪贴、奖金” 等相关表述。"
                   input-align="right"/>
        <van-field v-f-show="'skrbz'" v-model="formData.skrbz" :disabled="isDisabled('skrbz')"
                   :required="isRequired('skrbz')" :rules="getRules('skrbz')" name="skrbz" type="textarea"
                   maxlength="200" rows="3" autosize label="备注" show-word-limit placeholder="请输入备注"
                   input-align="right"/>
        <van-field v-f-show="'km'" v-model="formData.km" :required="isRequired('km')" name="flowName"
                   label="归属科目" placeholder="归属科目" input-align="right" :rules="getRules('km')">
          <template #input>
            <view-item @click.native="isShowPopup(km,'km')" :treeData="km.data" :value="formData.km"
                       placeholder="请选择归属科目"/>
            <van-popup position="bottom" v-model="km.show">
              <van-nav-bar title="选择归属科目" left-text="取消" right-text="确定" @click-left="km.show = false"
                           @click-right="kmSubmit"/>
              <van-search v-model="km.filterText" @input="treeSearch($event, $refs.tree)" clearable shape="round"/>
              <div style="overflow-y: auto" class="h-vh-35">
                <div class="p-10">
                  <el-tree ref="kmTree" @check-change="singleChoice($event,$refs.kmTree)" node-key="uuid" check-strictly
                           :data="km.data" :filter-node-method="filterNode" check-on-click-node show-checkbox/>
                </div>
              </div>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'fj'"  class="fileValueBox"  :value.prop="formData.fj" input-align="right" name="fj" :required="isRequired('fj')"
                   :rules="getRules('fj')" label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('fj')" :files="formData.fj" @success="uploadSuccess"
                         module-type="flow"  @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','fj')"></uploadFiles>
          </template>
        </van-field>
        
      </van-cell-group>
         <div v-f-show="'zcht'" v-if="formData.fklx=='供应商货款'">
        <div class="font-32 font-weight-500 cor-00 m-t-26">关联合同</div>
        <van-cell-group class="m-t-20">
          <van-field input-align="right" name="zcht" :required="isRequired('zcht')" :rules="getRules('zcht')"
                     :value="formData.zcht" label="支出合同" placeholder="请选择支出合同">
            <template #input>
              <view-item @click.native="isShowPopup(zcht,'zcht')" :value="formData.zcht" placeholder="请选择支出合同"/>
              <van-popup v-model="zcht.show" position="bottom">
                <van-nav-bar title="支出合同" left-text="取消" right-text="确定" @click-left="zcht.show = false"
                             @click-right="popupSubmit('zcht',{label:'contractName',value:'contractId'})"/>
              <van-row type="flex" align="center" class="p-r-20">
                <van-col :span="18">
                <van-search v-model="zcht.filterText" @input="pickerSearchZcht($event,zcht,'contractName')" clearable
                            shape="round"/>
                            </van-col>
                  <van-col :span="6">
                  <van-button :loading="btnLoading" @click="selectZchtList(true)" loading-text="加载中..."
                              type="primary" native-type="button" size="small">更多项目...
                  </van-button>
                </van-col>  
                </van-row>         
               <van-picker ref="zcht" value-key="contractName" :columns="zcht.filteredData"
                            @cancel="zcht.show = false"/>
              </van-popup>
            </template>
          </van-field>
        </van-cell-group>
      </div>

      <div v-f-show="'zffsmxb'">
        <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">财务出款</div>
        <van-cell-group v-for="(item,index) in formData.zffsmxb" :key="index" class="b-r-10 m-t-20">
          <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
            <van-row type="flex" align="center">
              <van-col :span="22">
                <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
                <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `明细${index + 1}` }}</span>
              </van-col>
              <van-col v-if="isShowIcon('zffsmxb')" @click="removeItem(index,'zffsmxb')" :span="2">
                <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
              </van-col>
            </van-row>
          </div>
          <van-field v-f-show="'fkzh'" input-align="right" name="fkzh" :rules="getRules('fkzh')"
                     :required="isRequired('fkzh')" :value="item.fkzh" label="付款账户" placeholder="请选择付款账户">
            <template #input>
              <view-item @click.native="popupShow(fkzh.show,index,'fkzh')" :value="item.fkzh"
                         placeholder="请选择付款账户"/>
              <van-popup v-model="fkzh.show[index]" position="bottom">
                <van-nav-bar title="选择付款账户" left-text="取消" right-text="确定"
                             @click-left="popupHidden(fkzh.show,index)" @click-right="fkzhSubmit(item,index)"/>
                <van-search v-model="fkzh.filterText" @input="pickerSearch($event,fkzh,'name')" clearable
                            shape="round"/>
                <van-picker :ref="`fkzhPicker_${index}`" value-key="name" :columns="fkzh.filteredData"
                            @cancel="fkzh.show = false"/>
              </van-popup>
            </template>
          </van-field>
          <van-field v-f-show="'zffs'" input-align="right" name="zffs" :rules="getRules('zffs')"
                     :required="isRequired('zffs')" :value="item.zffs" label="支付方式" placeholder="请选择支付方式">
            <template #input>
              <view-item @click.native="popupShow(zffs.show,index,'zffs')" :value="item.zffs"
                         placeholder="请选择支付方式"/>
              <van-popup v-model="zffs.show[index]" position="bottom">
                <van-nav-bar title="选择支付方式" left-text="取消" right-text="确定"
                             @click-left="popupHidden(zffs.show,index)" @click-right="zffsSubmit(item,index)"/>
                <van-search v-model="zffs.filterText" @input="pickerSearch($event,zffs,'name')" clearable
                            shape="round"/>
                <van-picker :ref="`zffsPicker_${index}`" value-key="name" :columns="zffs.filteredData"
                            @cancel="zffs.show = false"/>
              </van-popup>
            </template>
          </van-field>
          <van-field v-f-show="'zfmxje'" :disabled="isDisabled('zfmxje')" v-model="item.zfmxje" type="number"
                     name="zfmxje" :rules="getRules('zfmxje')" :required="isRequired('zfmxje')" :maxlength="10"
                     placeholder="请输入支付金额" label="支付金额" input-align="right"
                     @change="formatToTwoDecimals(formData, 'zfmxje')"></van-field>
        </van-cell-group>
        <van-row v-if="!isDisabled('zffsmxb')">
          <van-col :span="12"></van-col>
          <van-col :span="12">
            <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加出款明细" @click="addFKItem"
                        class="width-100"/>
          </van-col>
        </van-row>
      </div>
    </van-form>
    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class="m-t-20"
               :flowTraceList="flowTrace" :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="m-t-20" ref="approver" @addUser="addUser" :processData="processData" :formData="formData"
              :formItemMap="formItemMap"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false"
                   @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable
                  shape="round"/>
      <div style="overflow-y: auto" class="h-vh-50">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                   check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                   show-checkbox/>
        </div>
      </div>
    </van-popup>
    <account :show="account.show" @finish="accountFinish" @close="account.show = false"></account>
    <contract :show="contract.show" ref="contractSelect" :userId="currentUserInfo.userId + ''"
              @finish="businessSelectFinish" @close="contract.show = false"></contract>

  </div>
</template>
<script>
import {getCurrentUserDept, getDeptUserTreeAll, getUserPayCompany} from '@/api/user.js'
import {getFormDataByInstanceId, getSubjectTree, listContractAndProject, selectProjectDept} from "@/api/flow";
import cache from "@/plugins/cache";
import mixin from '@/mixin/flow'
import moment from "moment";
import {getDictDataByType} from "@/api/dict";
import {queryFmAccount} from "@/api/account";
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";
import account from '@/views/tripReimbursement/components/account.vue'
import contract from "@/views/reimbursement/components/contract.vue";
import {formatToTwoDecimals} from "@/utils/ruoyi";
import {getContractList} from '@/api/contract'

const zfItem = {
  // 支付方式
  zffs: "",
  // 付款账户
  fkzh: "",
  // 支付金额
  zfmxje: ""
}
export default {
  mixins: [mixin,fileMixins],
  components: {contract, approver, bottomBar, flowTrace, uploadFiles, account},
  data() {
    return {
      btnLoading: false,
      currentUserInfo: {},
      formData: {
        zmlx: ['管理账套', '核算账套'],
        flowNo: "",
        sqr: "",
        fksqr: "",
        ssbm: "",
        ssxm: "",
        skrfkbz: "",
        skrbz: "",
        fksy: "",
        fklx: "",
        fkze: '',
        zfrq: "",
        fkfs: "",
        zfdx: "",
        yhzh: "",
        khh: "",
        km: "",
        fkzh: "",
        hsgs: '',
        zffs: "",
        zcht: "",
        fj: [],
        zffsmxb: []
      },

      // 核算公司
      hsgs: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 归属科目
      km: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      zffs: {
        data: [{name: '现金'}, {name: '对公'}, {name: '其他'}],
        show: [],
        filteredData: [{name: '现金'}, {name: '对公'}, {name: '其他'}],
        filterText: '',
      },
      contract: {
        show: false,
      },
      fkfs: {
        data: [],
        show: false,
        filteredData: [],
        filterText: ''
      },
      rules: {},
      zfrq: {
        show: false,
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2030, 0, 1)

      },
      // 付款账户
      fkzh: {
        data: [],
        show: [],
        filteredData: [],
        filterText: '',
      },
      fklx: {
        data: [],
        show: false,
        filteredData: [],
        filterText: ''
      },
      // 所属部门
      ssbm: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      account: {
        show: false,
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      // 所属项目
      ssxm: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
        copyValue: []
      },
      // 关联合同
      zcht: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页条数
        total: 0 // 总条数
      },
      formItemMap: null, // 表单字段的Map
    }
  },
    watch: {
    'formData.fklx': {
      handler(nvl) {
        console.log('fklx', nvl)
        // 获取支出合同
        this.getContractList({ pageNum: 1, pageSize: 10})
      },
      deep: true
    },
    },
  created() {
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
          this.$loading.hide()
        })
      })
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.getCurrentUserDept(currentUserInfo)
      this.selectMyProjectList(currentUserInfo)
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) { // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        Object.assign(this.formData, res.data.formData)

        if (this.formData.hsgs) {
          let belongUnit = this.formData.hsgs.split(',')[0]
          // 获取付款账户
          this.queryFmAccount({belongUnit})
        }

        this.$loading.hide()
      })
    } else { // 新增时
      // 新增时调用
      this.getFormInfo({templateId: this.templateId, groupId: this.groupId}).then(res => {
        this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        Object.assign(this.formData, res.data.processTemplates.expressVals)
      })
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.currentUserInfo = currentUserInfo;
      this.getCurrentUserDept(currentUserInfo)
      this.selectMyProjectList(currentUserInfo)
      // 查询用户的核算公司列表
      this.selectUserPayCompany(currentUserInfo)
      // 获取付款账户
      this.queryFmAccount()
    }
  },
  methods: {
  getContractList(params) {
    // const params = {
    //   pageNum,
    //   pageSize,
    //   contractName: this.zcht.filterText
    // };
    return new Promise((resolve, reject) => {
      getContractList(params).then(res => {
        // 更新总条数
        this.zcht.total = res.total;
        // 如果是第一页，则替换数据；否则追加数据
        if(params.contractName){
           this.zcht.data = res.rows;
          this.zcht.filteredData = res.rows;
          return
        }
        if (params.pageNum === 1) {
          this.zcht.data = res.rows;
          this.zcht.filteredData = res.rows;
        } else {
          this.zcht.data = [...this.zcht.data, ...res.rows];
          this.zcht.filteredData = [...this.zcht.filteredData, ...res.rows];
        }
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },
    selectZchtList(loadMore = false) {
    if (loadMore) {
      // 增加页码
      this.zcht.pageNum += 1;
    } else {
      // 重置页码为第一页
      this.zcht.pageNum = 1;
    }

    // 调用分页接口
    this.btnLoading = true;
    this.getContractList({pageNum:this.zcht.pageNum, pageSize:this.zcht.pageSize}).finally(() => {
      this.btnLoading = false;
    });
    },
    pickerSearchZcht(){
      this.getContractList({contractName:this.zcht.filterText})
    },
    formatToTwoDecimals,
    init() {
      // 归属科目
      this.getSubject()
      // 获取部门用户树
      this.getDeptUserTreeAll()

      getDictDataByType('payment_type').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.fklx.data = data
        this.fklx.filteredData = data
      })
      getDictDataByType('payment_way').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.fkfs.data = data
        this.fkfs.filteredData = data
      })
    },
    // 获取人员核算工资地址列表
    selectUserPayCompany(user) {
      return new Promise(resolve => {
        getUserPayCompany({userId: user.id || user.userId}).then(res => {
          this.hsgs.data = res.data
          this.hsgs.filteredData = res.data
          if (res.data.length > 0 && (!this.$route.query.processInstanceId)) {
            res.data.forEach(item => {
              if (item.selFlag == '1') {
                this.formData.hsgs = item.id + "," + item.name
              }
            })
          }
          resolve(res.data)
        })
      })
    },
    businessSelectFinish(field) {
      const item = this.$refs[field].getValues()[0]
      console.log(item)
      selectProjectDept({id: item.id, type: item.typeValue}).then(res => {
        this.deptcost = res.data.unitName
      })
      this.$set(this.formData, 'ssxm', item.id + "," + item.name + "," + item.typeValue)
      this.$set(this[field], 'show', false)
      // this.$set(this.formData, field, item[props.value] + ',' + item[props.label])
    },

    // 显示合同选择框
    showContract() {
      if (!this.isDisabled('ssxm')) {
        this.contract.show = true
        this.$refs['contractSelect'].init()
      }
    },
    // 收款人账户信息
    accountFinish(select) {
      this.formData.zfdx = select[0].accountName
      this.formData.khh = select[0].accountBank
      this.formData.yhzh = select[0].accountNo
      this.account.show = false
    },
    queryFmAccount(params) {
      queryFmAccount(params).then(res => {
        this.fkzh.data = res.data
        this.fkzh.filteredData = res.data
      })
    },
    fkzhSubmit(item, index) {
      item.fkzh = this.$refs[`fkzhPicker_${index}`][0].getValues()[0].id + ',' + this.$refs[`fkzhPicker_${index}`][0].getValues()[0].name;
      if (this.$refs[`fkzhPicker_${index}`][0].getValues()[0].name.includes('基本户') || this.$refs[`fkzhPicker_${index}`][0].getValues()[0].name.includes('一般户')) {
        this.$set(item, 'zffs', '对公');
      } else {
        this.$set(item, 'zffs', '现金');
      }
      this.popupHidden(this.fkzh.show, index)
    },
    kmSubmit() {
      this.formData.km = this.$refs.kmTree.getCheckedNodes()[0].id;
      this.km.show = false
    },
    removeItem(index, field) {
      // if (this.formData[field].length === 1 && field !== 'relativeFlow') return this.$toast('请至少保留一项')
      this.$dialog.confirm({
        message: '确定删除该项吗？',
      }).then(() => {
        this.formData[field].splice(index, 1)
      })
    },
    // 归属科目
    getSubject() {
      getSubjectTree().then(res => {
        const data = this._getCategoryTree(res.data)
        this.km.data = data
        this.km.filteredData = data
      })
    },
    _getCategoryTree(treeList) {
      // 使用箭头函数来保持对 Vue 组件实例的 this 的引用
      const processTree = (originalItems) => {
        const newItems = []; // 创建一个新数组来存储处理过的节点
        originalItems.forEach(item => {
          const newItem = {...item}; // 创建一个新对象来避免修改原始数据
          newItem.disabled = newItem.children ? true : false;
          newItem.uuid = this.uuid(); // 确保正确访问 Vue 组件实例的方法
          if (newItem.children && newItem.children.length > 0) {
            newItem.children = processTree(newItem.children); // 递归调用并更新 children
          }
          newItems.push(newItem); // 将处理过的节点添加到新数组中
        });
        return newItems; // 返回新数组
      };
      return processTree(treeList); // 启动递归处理并返回新的树列表
    },
    zfrqConfirm(date) {
      this.formData.zfrq = moment(date).format('YYYY-MM-DD')
      this.zfrq.show = false
    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.fj = fileList
    },
    addFKItem() {
      this.formData.zffsmxb.push(JSON.parse(JSON.stringify(zfItem)));
    },
    zffsSubmit(item, index) {
      item.zffs = this.$refs[`zffsPicker_${index}`][0].getValues()[0].name;
      this.popupHidden(this.zffs.show, index)
    },
    // 报销人弹窗
    handlePopupSubmit() {
      if (this.$refs.tree.getCheckedNodes().length <= 0) {
        this.$toast({message: '请至少选择一人', position: 'bottom'})
        return
      }
      this.formData.hsgs = ''
      this.formData.fksqr = this.$refs.tree.getCheckedNodes()[0].id
      // 切换人部门列表跟着换
      this.getCurrentUserDept(this.$refs.tree.getCheckedNodes()[0])
      // 切换人 项目列表跟着换
      this.selectMyProjectList(this.$refs.tree.getCheckedNodes()[0])
      // 切换人 重新请求核算公司列表
      this.selectUserPayCompany(this.$refs.tree.getCheckedNodes()[0])
      this.formData.ssbm = ''
      this.formData.ssxm = ''
      this.deptUserTreeAll.show = false
    },
    // 获取人员所属部门列表
    getCurrentUserDept(user) {
      return new Promise(resolve => {
        getCurrentUserDept({userId: user.id || user.userId}).then(res => {
          this.ssbm.data = res.data
          // 搜索过滤
          this.ssbm.filteredData = this.ssbm.data
          resolve(res.data)
        })
      })
    },
    // 获取人员所属项目列表
    selectMyProjectList(user, more) {
      this.btnLoading = true
      const params = {
        userId: user.id || user.userId,
        more
      }
      return new Promise((resolve) => {
        listContractAndProject(params).then(res => {
          this.btnLoading = false
          this.ssxm.data = res.data
          this.ssxm.filteredData = res.data.map(item => ({
            ...item,
            columnsLabel: `${item.type}-${item.name}`
          }))
          resolve(res.data)
        })
      })
    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
        })
      })
    },
  }
}
</script>
